module.exports = __webpack_public_path__ + "static/media/iitbhu.63ac0b8c.png";